import ChargeDetailView from './ChargeDetailView'
export default ChargeDetailView;